import React from 'react';
import * as S from './AlternateDates.styles';
import Shimmer from '../../../../components/Shimmer/Shimmer';

const SoldoutCardLoading = () => {
  return (
    <S.SoldOutDescWrapper>
      <Shimmer
        width={'30px'}
        height={'20px'}
        radius={'2px'}
        shimmerColor={
          'linear-gradient(to right, #E1E7EE 0%, #E1E7EE 20%, #E1E7EE 40%, #E1E7EE 100%)'
        }
        customStyle={{
          alignItems: 'flex-end',
          justifyContent: 'flex-end',
          display: 'flex',
          marginLeft: 'auto',
        }}
        data-testid="alternate-dates-loading"
      />
      <S.SoldOutHeaderText>
        <Shimmer
          width={'60px'}
          height={'20px'}
          radius={'2px'}
          shimmerColor={
            'linear-gradient(to right, #E1E7EE 0%, #E1E7EE 20%, #E1E7EE 40%, #E1E7EE 100%)'
          }
          customStyle={{
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
            display: 'flex',
            marginLeft: 'auto',
          }}
          data-testid="alternate-dates-loading"
        />
      </S.SoldOutHeaderText>
      <S.SoldOutDescText>
        <S.SoldOutDescText>
          <Shimmer
            width={'300px'}
            height={'20px'}
            radius={'2px'}
            shimmerColor={
              'linear-gradient(to right, #E1E7EE 0%, #E1E7EE 20%, #E1E7EE 40%, #E1E7EE 100%)'
            }
            customStyle={{
              alignItems: 'flex-end',
              justifyContent: 'flex-end',
              display: 'flex',
              marginLeft: 'auto',
            }}
            data-testid="alternate-dates-loading"
          />
        </S.SoldOutDescText>
      </S.SoldOutDescText>
    </S.SoldOutDescWrapper>
  );
};

export default SoldoutCardLoading;
